import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing survey information
 */
const create = () => {
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create();

    const setSurvey = (payload) => api.post(ApiPaths.SURVEY, payload);
    
    // Return back a collection of functions
    return {
        setSurvey
    }
}

// let's return back our create method as the default.
export default {
    create
}

